/* Editable list autocomplete; only a confirmed option changes the native select.
 * Keyboard model: https://www.w3.org/WAI/ARIA/apg/patterns/combobox/ */
(function (global) {
  'use strict';
  const key = value => String(value || '').normalize('NFKD').replace(/\p{M}/gu, '').toLocaleLowerCase('de').replace(/[^\p{L}\p{N}]/gu, '');
  const tokens = value => String(value || '').split(/[^\p{L}\p{N}]+/u).filter(Boolean).map(key);
  const modelDigitsMatch = (label, query) => (String(query).match(/\d+/g) || []).every(digit => (String(label).match(/\d+/g) || []).includes(digit));
  function matches(label, query) {
    if (!modelDigitsMatch(label, query)) return false;
    return key(label).includes(key(query)) || tokens(query).every(token => tokens(label).some(word => word.includes(token)));
  }
  function oneTypo(a, b) {
    if (a === b) return true;
    if (Math.min(a.length, b.length) < 4 || Math.abs(a.length - b.length) > 1) return false;
    // Digits identify models; never correct them (F3 / F30, G30 / G2).
    if ((a.match(/\d+/g) || []).join('|') !== (b.match(/\d+/g) || []).join('|')) return false;
    let i = 0; while (a[i] && a[i] === b[i]) i++;
    if (a.length === b.length) return a.slice(i + 1) === b.slice(i + 1) ||
      (a[i] === b[i + 1] && a[i + 1] === b[i] && a.slice(i + 2) === b.slice(i + 2));
    return a.length > b.length ? a.slice(i + 1) === b.slice(i) : a.slice(i) === b.slice(i + 1);
  }
  function suggests(label, query) {
    return modelDigitsMatch(label, query) && tokens(query).length > 0 && tokens(query).every(token => tokens(label).some(word => word.includes(token) || oneTypo(word, token)));
  }
  function attach(select, name) {
    const isBrand = name === 'brand' || name.endsWith('-brand');
    const label = select.parentElement;
    const wrap = document.createElement('div');
    wrap.className = 'esv-picker';
    label.before(wrap); wrap.append(label);
    const input = document.createElement('input');
    input.type = 'text'; input.id = `esv-picker-${name}`; input.dataset.pickerInput = name;
    input.autocomplete = 'off'; input.spellcheck = false;
    input.setAttribute('role', 'combobox'); input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false'); input.setAttribute('aria-controls', `${input.id}-list`);
    label.htmlFor = input.id;
    label.append(input); select.hidden = true;
    const toggle = document.createElement('button');
    toggle.type = 'button'; toggle.className = 'esv-picker__toggle'; toggle.tabIndex = -1;
    toggle.setAttribute('aria-label', isBrand ? 'Marken anzeigen' : 'Modelle anzeigen');
    toggle.textContent = '⌄'; wrap.append(toggle);
    const popup = document.createElement('div');
    popup.className = 'esv-picker__popup'; popup.hidden = true;
    const list = document.createElement('div');
    list.id = `${input.id}-list`; list.setAttribute('role', 'listbox');
    list.setAttribute('aria-label', isBrand ? 'Marken' : 'Modelle');
    const status = document.createElement('div');
    status.className = 'esv-picker__status'; status.id = `${input.id}-status`; status.setAttribute('role', 'status');
    input.setAttribute('aria-describedby', status.id);
    const request = document.createElement('button');
    request.type = 'button'; request.className = 'esv-picker__request';
    request.textContent = 'Scooter nicht dabei? Anfrage stellen';
    request.addEventListener('mousedown', event => event.preventDefault());
    request.addEventListener('click', () => {
      wrap.dispatchEvent(new CustomEvent('esv:vehicle-request', { bubbles: true, detail: { kind: isBrand ? 'brand' : 'model', query: input.value.slice(0, 200) } }));
    });
    popup.append(list, status, request); wrap.append(popup);
    let visible = [], active = -1, suggested = false;
    function close(restore = true) {
      popup.hidden = true; wrap.classList.remove('is-open'); input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant'); active = -1;
      if (restore) input.value = select.value ? select.selectedOptions[0]?.textContent || '' : '';
    }
    function sync() {
      delete input.dataset.pickerDraft; close(); input.disabled = select.disabled; toggle.disabled = select.disabled;
      input.placeholder = select.disabled ? 'Zuerst Marke wählen' : isBrand ? 'Marke suchen …' : 'Modell suchen …';
    }
    function activate(index) {
      active = index;
      Array.from(list.children).forEach((row, i) => row.setAttribute('aria-selected', String(i === active)));
      const row = list.children[active];
      if (row) { input.setAttribute('aria-activedescendant', row.id); row.scrollIntoView({ block: 'nearest' }); }
      else input.removeAttribute('aria-activedescendant');
    }
    function open(query = '') {
      if (input.disabled) return;
      visible = Array.from(select.options).filter(o => o.value && !o.disabled && matches(o.textContent, query));
      suggested = !visible.length && Boolean(key(query));
      if (suggested) visible = Array.from(select.options).filter(o => o.value && !o.disabled && suggests(o.textContent, query));
      list.replaceChildren(); active = -1; input.removeAttribute('aria-activedescendant');
      visible.forEach((o, i) => {
        const row = document.createElement('div');
        row.id = `${input.id}-option-${i}`; row.setAttribute('role', 'option'); row.setAttribute('aria-selected', 'false');
        row.dataset.pickerValue = o.value; row.textContent = o.textContent; list.append(row);
      });
      status.textContent = suggested && visible.length ? 'Ähnliche Schreibweise gefunden. Bitte bestätige die passende Auswahl.' : visible.length ? `${visible.length} ${isBrand ? 'Marken' : 'Modelle'} zur Auswahl` : 'Keine passende Auswahl gefunden. Prüfe die Schreibweise oder frage deinen Scooter an.';
      popup.hidden = false; wrap.classList.add('is-open'); input.setAttribute('aria-expanded', 'true');
      list.scrollTop = 0;
    }
    function choose(index) {
      const value = visible[index]?.value;
      if (!value) return;
      select.value = value; close();
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    input.addEventListener('focus', () => { open(); input.select(); });
    input.addEventListener('click', () => { if (popup.hidden) open(); });
    input.addEventListener('input', () => { input.dataset.pickerDraft = input.value; open(input.value); });
    input.addEventListener('blur', event => { if (!popup.contains(event.relatedTarget)) close(); });
    request.addEventListener('blur', event => { if (event.relatedTarget !== input && !popup.contains(event.relatedTarget)) close(); });
    request.addEventListener('keydown', event => { if (event.key === 'Escape') { event.preventDefault(); input.focus(); close(); } });
    input.addEventListener('keydown', event => {
      if (event.isComposing) return;
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        if (popup.hidden) open();
        if (visible.length) activate(active < 0 ? event.key === 'ArrowDown' ? 0 : visible.length - 1 : Math.max(0, Math.min(visible.length - 1, active + (event.key === 'ArrowDown' ? 1 : -1))));
      } else if (event.key === 'Enter' && !popup.hidden) {
        event.preventDefault(); choose(active >= 0 ? active : !suggested && visible.length === 1 ? 0 : -1);
      } else if (event.key === 'Escape' && !popup.hidden) { event.preventDefault(); close(); }

    });
    // Keep input focus during pointer selection; also avoids accepting on touch scroll.
    list.addEventListener('mousedown', event => event.preventDefault());
    list.addEventListener('click', event => {
      const row = event.target.closest('[data-picker-value]');
      if (row && list.contains(row)) choose(visible.findIndex(o => o.value === row.dataset.pickerValue));
    });
    toggle.addEventListener('mousedown', event => event.preventDefault());
    toggle.addEventListener('click', () => {
      if (!popup.hidden) { close(); return; }
      input.focus(); open();
    });
    sync();
    return { sync };
  }
  const api = { attach, matches, suggests };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else global.EsvSearchPicker = api;
})(typeof window !== 'undefined' ? window : globalThis);
